import { Link } from "react-router-dom";
import { topics } from "@/mocks/content";

export default function TopicSection() {
  return (
    <section id="topics" aria-labelledby="topic-title" className="w-full bg-background-50">
      <div className="mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        <div className="mb-6">
          <h2 id="topic-title" className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            热门专题
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            把同类瓜料装进一个专题，按脉络一次看全
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic, index) => (
            <Link
              key={topic.slug}
              to={`/topic/${topic.slug}`}
              className={`group overflow-hidden rounded-lg border border-background-200/80 bg-background-100/50 transition-colors duration-200 hover:border-primary-300 ${
                index === 0 ? "sm:col-span-2 lg:col-span-1" : ""
              }`}
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={topic.cover}
                  alt={`${topic.title}专题封面`}
                  title={`${topic.title} - 吃瓜日报热门专题`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-xs font-medium text-foreground-800">
                  {topic.articleCount} 篇
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors duration-200 group-hover:text-primary-600">
                  {topic.title}
                </h3>
                <p className="clamp-2 mt-2 text-sm leading-relaxed text-foreground-600">
                  {topic.desc}
                </p>
                <span className="mt-3.5 flex items-center gap-1 text-xs font-medium text-accent-700">
                  进入专题
                  <i className="ri-arrow-right-line text-sm" aria-hidden="true" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}